import React, { Component } from 'react'
import startCase from 'lodash/startCase'
import greenCheck from '../../assets/images/green-check.svg'
import iconPending from '../../assets/images/icon-pending.svg'
import { UserVerificationRow } from './userVerificationRow'
import { Card } from '../../components/card'
import { User } from '../../core/types'

export interface Props {
  user: User
}

export class UserVerifications extends Component<Props> {
  static displayName = 'UserVerifications'

  internalUrl = (title, id) => {
    return title === "Driver's license" ? `/tasks/${id}/edit` : null
  }

  constructVerifications = (userVerifications) => {
    const verifications = userVerifications.map((verification) => {
      const { status, title, taskId } = verification
      switch (status) {
        case 'COMPLETE':
          return (
            <UserVerificationRow
              key={title}
              path={this.internalUrl(title, taskId)}
            >
              <p className="user-verifications__row-title user-verifications__row-title--bold">
                {startCase(title)}
              </p>
              <img className="user-verifications__row-image" src={greenCheck} />
            </UserVerificationRow>
          )
        case 'PENDING':
          return (
            <UserVerificationRow
              key={title}
              path={this.internalUrl(title, taskId)}
            >
              <p className="user-verifications__row-title user-verifications__row-title--bold">
                {startCase(title)}
              </p>
              <img
                className="user-verifications__row-image"
                src={iconPending}
              />
            </UserVerificationRow>
          )
        default:
          return (
            <UserVerificationRow
              key={title}
              path={this.internalUrl(title, taskId)}
            >
              <p className="user-verifications__row-title">
                {startCase(title)}
              </p>
            </UserVerificationRow>
          )
      }
    })
    return verifications
  }

  render() {
    const {
      user: { userVerifications },
    } = this.props

    return (
      <Card title="Verifications" gridClass="user-verifications">
        {userVerifications ? (
          this.constructVerifications(userVerifications)
        ) : (
          <p>No Verifications</p>
        )}
      </Card>
    )
  }
}

export default UserVerifications
